import InfoDetail from '../../views/info/Detail.vue';

// お知らせ詳細
window.Vue.component('info-detail', InfoDetail);
